import styled from 'styled-components';

const BadgeFLexContainer = styled.div`
  display: flex;
  flex-direction: row; 
  flex-wrap: wrap;
`
export default BadgeFLexContainer;